<template>
  <v-dialog v-model="dialog" @keydown.esc="dialog = false" @click:outside="dialog = false" persistent max-width="650">
    <div id="modalform" tabindex="-1" ref="modalform">
      <v-card>
        <v-card-title style="color:#02B28A; font-weight: 700; justify-content: space-between; background: #EFFAF4;">
          <div></div>
          <div>配置人数の上限エラー</div>
          <div><button class="btn_close" @click="dialog = false">✕</button></div>
        </v-card-title>
        <v-card-text style="padding: 30px 70px;">
          勤務回数が不足しているため日ごとに必要な職員配置が不足する可能性があります。
          [不足する勤務区分 <template v-for="(val, key, index) in alert_per_workcategory">
            {{ val.workpattern_category_jpn_short_name }}:{{ val.shortage_cnt }}人不足
            <template v-if="index < Object.keys(alert_per_workcategory).length - 1">、</template>
          </template>]<br>
        </v-card-text>

        <v-card-text style="padding: 30px 70px;">
          <p class="title_green_line">
            ■ 解消方法
          </p>
          <p>
            ・勤務区分が不足となっている職員の勤務回数上限を増やしてください。（設定は
            <span class="link_text" @click="sendPage()">こちら</span>）
          </p>
        </v-card-text>

        <v-card-actions style="padding: 0;">
          <v-spacer></v-spacer>
            <div style="display: flex; justify-content: center; width: 100%; padding: 0px 70px 70px 70px;">
            <button class="btn_gray_shadow" style="width:150px; padding: 5px 0;" @click="dialog = false">閉じる</button>
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>

</template>

<script>

export default {
    name: 'AlertWorkCategoryDialog',
    components: {},
    props: {
      alert_per_workcategory:{
        type: Object
      },
      officeId: {
        type: Number,
      },
      teamId: {
        type: Number,
        default: 0,
      },
      year: {
        type: String,
      },
      month: {
        type: String,
      },
    },
    data () {
      return {
          dialog: false,
      }
    },
    methods: {
      openDialog() {
        this.dialog = true;
      },
      // loadingの制御
      updateLoading(flg) {
        EventBus.$emit('updateLoading', flg);
      },
      sendPage() {
        this.$inertia.get(this.$route('offices.work-counts.edit-many', {
          office: this.officeId,
          team_id: this.teamId,
          year: this.year,
          month: this.month,
          sort_type: 1,
        }));
        this.updateLoading(true);
      },
    },
    mounted() {
    }
}
</script>
